import type { EFakturaAddGivenPermissionRequest, EFakturaCreditor } from '../../../generated-types';
import { addEfakturaGivenPermission } from '../../../services/eFakturaService';
import EfakturaSharingState from './state';

export default (formState: EfakturaSharingState) => {
    const issuers: EFakturaCreditor[] | undefined = formState.selected?.map((issuer) => ({
        creditorId: issuer.creditorId,
        name: issuer.name,
        isBlocked: false,
    }));
    const request: EFakturaAddGivenPermissionRequest = {
        customerNumber: { value: formState.ssn ?? '' },
        disponentName: formState.name ?? '',
        selectedIssuers: issuers,
        deviceId: window.ReactNativeProps?.deviceId,
    };
    return addEfakturaGivenPermission(request);
};
